import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentSection, Heading } from "@cinch-labs/design-system";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { InstructionsTable } from "../instructions-table/instructions-table";
import styles from "./delete-cookies-section.module.css";
export var DeleteCookiesSection = function(param) {
    var title = param.title, pcNote = param.pcNote, pcInstructions = param.pcInstructions, macNote = param.macNote, macInstructions = param.macInstructions;
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                element: "h2",
                className: styles.title,
                fontSize: "h1",
                children: title
            }),
            /*#__PURE__*/ _jsx(ContentSection, {
                children: pcNote && renderWithResolver(pcNote)
            }),
            /*#__PURE__*/ _jsx(InstructionsTable, {
                instructions: pcInstructions
            }),
            /*#__PURE__*/ _jsx(ContentSection, {
                children: macNote && renderWithResolver(macNote)
            }),
            /*#__PURE__*/ _jsx(InstructionsTable, {
                instructions: macInstructions
            })
        ]
    });
};
